// extracted by mini-css-extract-plugin
module.exports = {"lds_ring":"LoaderIndicatorStyle__lds_ring--2D1nV"};